import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=6a9fe7f2&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports